import parse from 'html-react-parser'
class ActionProvider {
    constructor(createChatBotMessage, setStateFunc) {
      this.createChatBotMessage = createChatBotMessage;
      this.setState = setStateFunc;
    }
    
    greet() {
        // const greetingMessage = this.createChatBotMessage('Hi, friend.');
        // this.updateChatbotState(greetingMessage);

        const greetingMessage = this.createChatBotMessage('Salut. Comment pouvons-nous vous aider ?');
        this.updateChatbotState(greetingMessage);
    }

    careers() {
      const careersMessage = this.createChatBotMessage(parse('Power your future with a career at Interac. <a href="https://www.interac.ca/en/about/careers/">Learn</a> about open positions.'));
      this.updateChatbotState(careersMessage);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    }

    contactUs() {
      const contactUs = this.createChatBotMessage(parse('Visit our <a href="https://www.interac.ca/en/contact-us/">contact us</a> page for details.'));
      this.updateChatbotState(contactUs);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    }


    WhatIseTransfer() {
      const WhatIseTransferMessage = this.createChatBotMessage(parse('<em>Interac</em> e-Transfer is a fast, secure and convenient way to send money to anyone in Canada using online banking. The participating bank or credit union transfers the funds using established and secure banking procedures. Transfers are almost instant, but can take up to 30 minutes depending on your bank or credit union.'));
      this.updateChatbotState(WhatIseTransferMessage);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    }

  eTransferContact() {
    const eTransferContactMessage = this.createChatBotMessage(parse('Please contact your bank or credit union to troubleshoot any transactions in progress. The contact information is usually on the back of your <em>Interac</em> debit card. You can also use this <em>Interac</em> e-Transfer form.'));
    this.updateChatbotState(eTransferContactMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }

  eTransferHowToSend() {
    const eTransferHowToSend = this.createChatBotMessage(parse('Exact steps vary by individual bank or credit union, but the process will always be simple. Just log into your online bank account, navigate to the <em>Interac</em> e-Transfer section and follow the instructions.'));
    this.updateChatbotState(eTransferHowToSend);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }

  eTransferHowToCancel() {
    const eTransferHowToCancel = this.createChatBotMessage(parse('To cancel a transfer, log into your online bank account. Go to the transaction or payment history and select the <em>Interac</em> e-Transfer transaction you wish to cancel. Use the cancel option provided. This process varies by financial institution, who may also charge a cancellation fee. Contact your bank or credit union for more information.'));
    this.updateChatbotState(eTransferHowToCancel);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }

  HowToDeposit() {
    const HowToDepositMessage = this.createChatBotMessage(parse('When someone sends you money via <em>Interac</em> e-Transfer, you will receive an email or text message that a transfer has been sent to you. The notification includes information such as Sender\'s name, Transfer amount A link to deposit your transfer to your bank account. The fastest way to get your funds is through your financial institution’s online or mobile banking service. Simply click the link in the notification, select your bank or credit union, login to online or mobile banking and deposit the money into the account of your choice. If you cannot click on the link, either cut and paste or type the link into your browser. You will be prompted to enter the answer to a security question set by the sender, as part of the secure login process. Alternatively, Autodeposit is an <em>Interac</em> e-Transfer feature that allows users to register to have incoming <em>Interac</em> e–Transfer funds deposited directly into their bank account – no security question and answer needed. Learn more about <em>Interac</em> e-Transfer enhanced features below.'));
    this.updateChatbotState(HowToDepositMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }

  HowToSecureEtransfer() {
    const HowToSecureEtransferMessage = this.createChatBotMessage('You are not sending money by email or text message: Only the notification travels over the Internet to advise the recipient that the transfer has been initiated and to provide instructions on how to deposit the money. The money always resides safely at a financial institution and is transferred through existing payment networks that banks and credit unions have used for years to settle cheques, bank machine deposits and withdrawals. Security measures have been built into the system, including: Encryption technology, Confidential user IDs and passwords issued by financial institutions, Secure login process, A security question and answer to ensure only the intended recipient receives the money, 128-bit browser encryption.');
    this.updateChatbotState(HowToSecureEtransferMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }

  etransferCost() {
    const etransferCostMessage = this.createChatBotMessage(parse('There may be a fee from your financial institution for using the <em>Interac</em> e-Transfer service. Please check with your bank or credit union directly.'));
    this.updateChatbotState(etransferCostMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }

  etransferLimit() {
    const etransferLimitMessage = this.createChatBotMessage('Like most financial transactions, there are limits on the amount you can send. Each financial institution sets their own. Please contact your bank or credit union for details.');
    this.updateChatbotState(etransferLimitMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }

  etransferStopTxt() {
    const etransferStopTxtMessage = this.createChatBotMessage(parse('You received a text notification because the sender selected “text message” to send you money via <em>Interac</em> e-Transfer. We recommend you provide the sender with your email address instead for sending. To permanently stop all text notifications from <em>Interac</em> e-Transfer, reply to an <em>Interac</em> e-Transfer text with the message STOP (or text STOP to 100001). Please note: Once stopped, text message notifications cannot be reinstated for all transactions moving forward. Standard text messaging rates apply.'));
    this.updateChatbotState(etransferStopTxtMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }
  etransferNonCanadian() {
    const etransferNonCanadianMessage = this.createChatBotMessage('If you have received an <em>Interac</em> e-Transfer and do not have an account with a participating Canadian bank, ask your sender to cancel the transfer. Once the transfer is cancelled, the funds will be returned to the sender’s account. If you are unable to contact your sender, the transfer will expire in approximately 30 days. Once the transfer expires, the money is automatically deposited into the sender’s account.');
    this.updateChatbotState(etransferNonCanadianMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }

  etransferNoBank() {
    const etransferNoBankMessage = this.createChatBotMessage(parse('If your bank or credit union doesn’t offer <em>Interac</em> e-Transfer, you cannot receive funds. Please contact your bank or financial institution for additional information.'));
    this.updateChatbotState(etransferNoBankMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }
  etransferSecurityQA() {
    const etransferSecurityQAMessage = this.createChatBotMessage(parse('If you don’t know the answer to the security question, contact the sender. If you answer the security question incorrectly more than three times, the <em>Interac</em> e-Transfer transaction will automatically cancel.'));
    this.updateChatbotState(etransferSecurityQAMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }
  whatisAutodeposit() {
    const whatisAutodeposit = this.createChatBotMessage(parse('Autodeposit is an <em>Interac</em> e-Transfer feature that allows users to register to have incoming <em>Interac</em> e–Transfer funds deposited directly into their bank account – no security question and answer needed. <a href="https://www.interac.ca/en/consumers/products/interac-e-transfer/enhanced-features/#fi-list-autodeposit" target="_blank">Click here</a> for a list of participating banks and credit unions, and to learn more about the <em>Interac</em> e-Transfer Autodeposit feature.'));
    this.updateChatbotState(whatisAutodeposit);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }
  DebitWorks() {
    const DebitWorksMessage = this.createChatBotMessage(parse('<em>Interac</em> Debit and <em>Interac</em> Contactless transactions are approved by your bank or credit union through secure online systems in real-time. Transactions appear instantly on your bank account records, allowing you to monitor your available balance so you can keep track of your spending.'));
    this.updateChatbotState(DebitWorksMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }

  DebitSecurity() {
    const DebitSecurityMessage = this.createChatBotMessage(parse('<em>Interac</em> Debit and <em>Interac</em> Flash are extremely secure forms of payment with sophisticated safeguards and fraud detection tools in place to protect you: <em>Interac</em> debit cards use EMV secure chip processing to store and process data securely. This makes it next to impossible to create counterfeit cards and protects you against fraud tactics such as skimming, transaction replay and electronic pickpocketing. When you use <em>Interac</em> Debit on your mobile device, you enjoy the same security features as your <em>Interac</em> debit card, as well as your device’s standard security measures such as passcode or biometric ID verification. Transaction limits are set at $100 per transaction.  There is also added protection of a cumulative contactless limit set by individual banks or credit unions.  A cumulative limit is the maximum contactless spend limit that can be done by an individual <em>Interac</em> debit card before the user is promoted to reset the limit with a Chip and PIN transaction. This confirms that you are the authorized cardholder. You are also protected from any losses due to unauthorized transactions under the <em>Interac</em> Zero Liability Policy. If your card is lost or stolen, contact your bank or credit union right away.'));
    this.updateChatbotState(DebitSecurityMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }
  ApplePayDebit() {
    const ApplePayDebitMessage = this.createChatBotMessage(parse('<em>Interac</em> Debit on Apple Pay is a new way to make debit payments using <em>Interac</em> Debit on your eligible Apple device.<em>Interac</em> Debit for In-App & In-Browser payments is the easy, fast, and secure way for Canadians to pay directly from their bank account when shopping online using their mobile device. An in-app payment takes place within the merchant’s native mobile app. An in-browser payment takes place within a supported mobile browser (i.e Safari).'));
    this.updateChatbotState(ApplePayDebitMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }
  ApplePay() {
    const ApplePayMessage = this.createChatBotMessage(parse('<em>Interac</em> Debit cardholders with a debit card issued from participating financial institutions can use <em>Interac</em> Debit to pay with Apple Pay at merchants who accept <em>Interac</em> Flash contactless payments. For in-app and in-browser transactions, <em>Interac</em> debit cardholders with a debit card issued from participating financial institutions can pay on select merchant applications or mobile websites using Apple Pay. We are continuously working to onboard more issuers and merchants to support in-app and in-browser with <em>Interac</em> Debit.'));
    this.updateChatbotState(ApplePayMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }
  requestMoney() {
    const requestMoneyMessage = this.createChatBotMessage(parse('Request Money is a feature that allows you to send a request for funds via the <em>Interac</em> e-Transfer system. To learn more about <em>Interac</em> e-Transfer, click here. Once the request is fulfilled and the funds are available in your account, you will receive a notification via text or email.'));
    this.updateChatbotState(requestMoneyMessage);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }
  whatisOpenPayment() {
    const whatisOpenPayment = this.createChatBotMessage(parse('Transit Open Payments or open payment fare systems provide the ability for transit riders to tap a payment card or a mobile wallet at fare readers without the need to use a transit fare card or transit app to pay for their fare. Interac is enabling the ability for a debit card or mobile wallet supported by <em>Interac</em><sup>&reg;</sup> Debit to be used for this purpose.'));
    this.updateChatbotState(whatisOpenPayment);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }
  whereCanIUseDebitonTransit() {
    const whereCanIUseDebitonTransit = this.createChatBotMessage(parse('The ability to pay for transit directly via Interac Debit is available by Metrolinx on the UP Express in Toronto and TransLink in Vancouver.Additional transit authorities across the GTHA have recently been added including GO Transit, Brampton Transit, Burlington Transit, Durham Region Transit, Hamilton Street Railway, MiWay in Mississauga, Oakville Transit, York Region Transit, Para Transpo in Ottawa and more to come.'));
    this.updateChatbotState(whereCanIUseDebitonTransit);

    const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
  }
  tryAgain() {
    const tryAgainMessage = this.createChatBotMessage(parse('Sorry I\'m still learning and didn\'t understand your question. Try using different key words, or <a href="https://www.interac.ca/en/contact-us/" target="_blank">Contact Us</a> for further assistance.'));
    this.updateChatbotState(tryAgainMessage);
  }


  moreQuestions () {
    const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
      {
        widget: 'learningOptions',
      }
    );
    this.updateChatbotState(moreQuestionsMessage);
  }

  handleGreet = () => {
    const message = this.createChatBotMessage(
      'Hi there! You can use this tool to help you find answers to your questions about Interac products and services. Please select one of the options below.',
      {
        widget: 'learningOptions',
      }
    );

    this.updateChatbotState(message);
  };

  handleGeneralQuestions = () => {
      const message = this.createChatBotMessage(
        'How can we help?',
        {
          widget: 'GeneralQuestions',
        }
      );
  
      this.updateChatbotState(message);
    };

    handleFunctionalityQuestions = () => {
      const message = this.createChatBotMessage(
        'How can we help?',
        {
          widget: 'FunctionalityQuestions',
        }
      );
  
      this.updateChatbotState(message);
    };
    handlePaymentsRefunds = () => {
      const message = this.createChatBotMessage(
        'How can we help?',
        {
          widget: 'PaymentsRefunds',
        }
      );
  
      this.updateChatbotState(message);
    };

    handleGeneral1 = () => {
      const handleGeneral1 = this.createChatBotMessage(parse('La solution de paiement KONEK, qui fait actuellement l’objet d’essais bêta sur invitation seulement, est une toute nouvelle option de paiement en ligne conçue au Canada. Elle donnera aux Canadiens plus de choix et de contrôle quant à la façon dont ils effectuent des opérations en ligne en toute sécurité auprès des commerçants participants. KONEK a été conçu par Interac Corp. en collaboration avec les principales institutions financières du Canada. De plus amples informations sur KONEK seront accessibles à l’approche de son lancement.'));
      this.updateChatbotState(handleGeneral1);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleGeneral2 = () => {
      const handleGeneral2 = this.createChatBotMessage(parse('KONEK, qui fait actuellement l’objet d’essais bêta sur invitation seulement, est pris en charge par les principales institutions financières du Canada et alimenté par Interac Corp.'));
      this.updateChatbotState(handleGeneral2);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleGeneral3 = () => {
      const handleGeneral3 = this.createChatBotMessage(parse('Le service KONEK fait actuellement l’objet d’essais bêta sur invitation seulement auprès d’un petit nombre de commerçants. Consultez régulièrement le site KONEK.ca pour obtenir une liste à jour des commerçants.'));
      this.updateChatbotState(handleGeneral3);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleGeneral4 = () => {
      const handleGeneral4 = this.createChatBotMessage(parse('L’essai bêta est une occasion pour les utilisateurs d’essayer un produit dans un environnement de production afin de découvrir d’éventuels bogues ou problèmes avant que le service soit plus largement accessible. Le service KONEK fait actuellement l’objet d’essais bêta sur invitation seulement. De plus amples informations sur KONEK seront accessibles à l’approche de son lancement complet.'));
      this.updateChatbotState(handleGeneral4);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleGeneral5 = () => {
      const handleGeneral5 = this.createChatBotMessage(parse('Le service KONEK fait actuellement l’objet d’essais bêta sur invitation seulement par l’intermédiaire de la RBC, de la Banque TD, de la Banque Nationale et de la Banque Scotia. De plus amples informations sur KONEK seront accessibles à l’approche de son lancement.'));
      this.updateChatbotState(handleGeneral5);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleGeneral6 = () => {
      const handleGeneral6 = this.createChatBotMessage(parse('KONEK fait actuellement l’objet d’essais bêta sur invitation seulement. Surveillez le site KONEK.ca à l’approche du lancement.'));
      this.updateChatbotState(handleGeneral6);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleGeneral7 = () => {
      const handleGeneral7 = this.createChatBotMessage(parse('Le service KONEK fait actuellement l’objet d’essais bêta auprès d’un petit nombre de commerçants. Pour en savoir plus sur KONEK, vous pouvez communiquer directement avec votre acquéreur ou remplir ce formulaire de demande.'));
      this.updateChatbotState(handleGeneral7);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handleFunc1 = () => {
      const handleFunc1 = this.createChatBotMessage(parse('KONEK fait actuellement l’objet d’essais bêta sur invitation seulement. Si vous participez au projet pilote d’essais bêta, vous pouvez utiliser le système pour traiter les opérations auprès des commerçants suivants (INSERT HERE). La première fois que vous utilisez KONEK, vous n’avez qu’à sélectionner KONEK à la caisse, à sélectionner votre institution financière à partir de la liste, à ouvrir une session au moyen de votre compte de services bancaires en ligne, à donner votre consentement, à choisir votre mode de paiement privilégié accepté par le commerçant et à effectuer votre achat. Si vous choisissez de créer un profil, votre mode de paiement privilégié sera sauvegardé la prochaine fois que vous utiliserez KONEK sur le même appareil.'));
      this.updateChatbotState(handleFunc1);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handlePaymentsRefunds1 = () => {
      const handlePaymentsRefunds1 = this.createChatBotMessage(parse('KONEK fait actuellement l’objet d’essais bêta sur invitation seulement. Si vous participez au projet pilote d’essais bêta et que vous devez obtenir un remboursement, ce dernier sera traité de la même façon que le paiement initial. Une fois que vous aurez retourné votre article au commerçant, vous obtiendrez votre remboursement selon le mode de paiement que vous avez choisi auprès de votre institution financière au moment du paiement. Les politiques de remboursement varient d’un commerçant à l’autre; si vous avez des questions au sujet des remboursements, veuillez communiquer directement avec le commerçant.'));
      this.updateChatbotState(handlePaymentsRefunds1);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    handlePaymentsRefunds2 = () => {
      const handlePaymentsRefunds2 = this.createChatBotMessage(parse('KONEK fait actuellement l’objet d’essais bêta sur invitation seulement. Si vous participez au projet pilote d’essais bêta et que vous avez des questions sur votre commande et la façon de l’annuler, veuillez communiquer directement avec le commerçant.'));
      this.updateChatbotState(handlePaymentsRefunds2);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    handlePaymentsRefunds3 = () => {
      const handlePaymentsRefunds3 = this.createChatBotMessage(parse('KONEK fait actuellement l’objet d’essais bêta sur invitation seulement. Si vous participez au projet pilote d’essais bêta, après avoir sélectionné votre type de paiement dans la liste et une fois que le paiement a été approuvé par votre institution financière, vous devriez voir un écran de confirmation de commande du commerçant. Si vous avez des questions ou des préoccupations au sujet de la confirmation de commande ou de paiement, veuillez communiquer avec le commerçant.'));
      this.updateChatbotState(handlePaymentsRefunds3);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handlePaymentsRefunds4 = () => {
      const handlePaymentsRefunds4 = this.createChatBotMessage(parse('KONEK is currently in beta testing by invitation only. If you are part of the beta test and have a question about your online purchase (e.g., delivery time, shipping options, product information, etc.), please contact the merchant.<br /><br />If you have questions or concerns about your payment using the KONEK service (e.g., limits, charges to your accounts, processing times, etc.) that cannot be answered by the merchant, please contact your financial institution.<br /><br />If you have a technical issue with KONEK (e.g., payment timing out, error message, etc.) please contact your financial institution.'));
      this.updateChatbotState(handlePaymentsRefunds4);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handlePaymentsRefunds5 = () => {
      const handlePaymentsRefunds5 = this.createChatBotMessage(parse('KONEK fait actuellement l’objet d’essais bêta sur invitation seulement. Si vous participez au projet pilote d’essais bêta et que vous avez une question sur vos achats en ligne (délai de livraison, options d’expédition, renseignements sur le produit, etc.), veuillez communiquer avec le commerçant.<br />Pour toute question ou préoccupation relatives à votre paiement effectué au moyen du service KONEK à laquelle le commerçant ne peut pas répondre (limites, frais portés à vos comptes, délais de traitement, etc.), veuillez communiquer avec votre institution financière.<br />Si vous avez un problème technique avec KONEK (p. ex., délai de paiement écoulé, message d’erreur), veuillez communiquer avec votre institution financière.'));
      this.updateChatbotState(handlePaymentsRefunds5);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };
    handlePaymentsRefunds6 = () => {
      const handlePaymentsRefunds6 = this.createChatBotMessage('KONEK fait actuellement l’objet d’essais bêta sur invitation seulement. KONEK a été élaboré en collaboration avec Interac et les institutions financières canadiennes participantes. Lorsque vous payez au moyen de KONEK, le service utilise les protocoles d’authentification et de consentement de paiement sécurisés de votre institution financière, et les données de paiement sensibles comme les numéros de carte ou de compte sont remplacées par des numéros aléatoires par création de jetons, de sorte que seules les données nécessaires pour effectuer l’opération sont échangées avec le commerçant. Pour obtenir de plus amples renseignements, veuillez consulter notre énoncé de confidentialité au KONEK.ca.');
      this.updateChatbotState(handlePaymentsRefunds6);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    handlePaymentsRefunds7 = () => {
      const handlePaymentsRefunds7 = this.createChatBotMessage(parse('KONEK fait actuellement l’objet d’essais bêta sur invitation seulement. KONEK a été élaboré en collaboration avec Interac et les institutions financières canadiennes participantes. Lorsque vous payez au moyen de KONEK, le service utilise les protocoles d’authentification et de consentement de paiement sécurisés de votre institution financière, et les données de paiement sensibles comme les numéros de carte ou de compte sont remplacées par des numéros aléatoires par création de jetons, de sorte que seules les données nécessaires pour effectuer l’opération sont échangées avec le commerçant.'));
      this.updateChatbotState(handlePaymentsRefunds7);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    handleRequestMoney2 = () => {
      const handleRequestMoney2 = this.createChatBotMessage(parse('KONEK fait actuellement l’objet d’essais bêta sur invitation seulement. Nous travaillons avec des intervenants des experts en sécurité pour maintenir la sécurité continue de nos services, mais il y a des mesures qu’il est important que vous preniez pour vous protéger contre la fraude, comme la création de mots de passe robustes et l’utilisation d’un logiciel antivirus sur tous vos appareils. Vous devriez aussi vérifier régulièrement vos relevés de compte pour vous assurer que les opérations y figurant ont été correctement traitées. Si certaines d’entre elles sont inexactes, par exemple s’il en manque ou s’il y en a en trop, communiquez avec votre institution financière.'));
      this.updateChatbotState(handleRequestMoney2);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    };

    handleFeedback = () => {
      const message = this.createChatBotMessage(
        'Vos commentaires sont toujours les bienvenus. Dites-moi ce que vous avez pensé de mon service aujourd’hui.',
        {
          widget: 'Feedback',
        }
      );
  
      this.updateChatbotState(message);
    };
    handleLikedIt = () => {
      const message = this.createChatBotMessage(
        'Merci pour les commentaires positifs. Comme je cherche toujours à apprendre, dites-moi s’il y a d’autres questions avec lesquelles je peux vous aider.',
      );
  
      this.updateChatbotState(message);
    };
    handleHatedIt = () => {
      const message = this.createChatBotMessage(
        'Désolé de ne pas avoir pu vous aider. Comment puis-je m’améliorer la prochaine fois?',
      );
  
      this.updateChatbotState(message);
    };
    handleSoSo = () => {
      const message = this.createChatBotMessage(
        'Désolé de ne pas avoir pu vous aider. Comment puis-je m’améliorer la prochaine fois?',
      );
  
      this.updateChatbotState(message);
    };
  
    updateChatbotState(message) {
      // NOTICE: This function is set in the constructor, and is passed in from the top level Chatbot component. The setState function here actually manipulates the top level state of the Chatbot, so it's important that we make sure that we preserve the previous state.
  
      this.setState((prevState) => ({
        ...prevState,
        messages: [...prevState.messages, message],
      }));
    }
    contactUs() {
      const contactUs = this.createChatBotMessage(parse('Visit our <a href="https://www.interac.ca/en/contact-us/">contact us</a> page for details.'));
      this.updateChatbotState(contactUs);

      const moreQuestionsMessage = this.createChatBotMessage(parse('Y a-t-il autre chose que je puisse aider ?'),
        {
          widget: 'MoreQuestions',
        }
      );
      this.updateChatbotState(moreQuestionsMessage);
    }
  }
  
  export default ActionProvider;